<script setup lang="ts">
const { isMobile } = useSize();
</script>

<template>
    <div class="organizational-solutions-root">
        <div class="content">
            <mr-typography
                size="x-large"
                weight="700"
                color="var(--cool-gray-800)"
            >
                راهکارهای سازمانی
            </mr-typography>
            <mr-typography weight="500" color="var(--cool-gray-600)">
                خدمات اختصاصیِ مِستربلیط برای ماموریت‌های کاری و رفاهیاتِ پرسنلِ
                سازمان‌ها
            </mr-typography>
            <mr-button
                :full-width="isMobile"
                class="activation-btn"
                variant="bordered"
                href="/b2b"
                link="nuxt"
            >
                فعال‌سازی پنل سازمانی
            </mr-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
.organizational-solutions-root {
    display: flex;
    align-items: center;
    padding: 24px;
    gap: 24px;
    border-radius: 16px;
    background-color: usePalette($p-gray, $p-100);
    @include mobile-only {
        flex-direction: column;
    }

    .image {
        width: 150px;
        height: 150px;
        border-radius: 8px;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 8px;

        @include mobile-only {
            align-items: center;
        }

        .activation-btn {
            @include desktop-only {
                width: fit-content;
            }
        }
    }
}
</style>
